module.exports = __webpack_public_path__ + "img/pop-up_2.da45aff6.jpg";